import * as React from "react";
import { styled } from "styled-components";
const OuterWrapper = styled.div `
  position: relative;
  width: 100%;
  height: 0;
  padding-bottom: ${(props) => (1 / props.ratio) * 100}%;
`;
const InnerWrapper = styled.div `
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
`;
export const AspectRatio = ({ children, ratio, }) => (React.createElement(OuterWrapper, { ratio: ratio },
    React.createElement(InnerWrapper, null, children)));
export default AspectRatio;
//# sourceMappingURL=AspectRatio.js.map